import { Component, forwardRef, Input } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  standalone: false,
  selector: 'admin-date-range-picker',
  templateUrl: './admin-date-range-picker.component.html',
  styleUrls: ['./admin-date-range-picker.component.css'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => AdminDateRangePickerComponent),
      multi: true,
    },
  ],
})
export class AdminDateRangePickerComponent implements ControlValueAccessor {
  @Input() format = 'yyyy-MM-dd';
  @Input() allowClear = true;
  @Input() placeholders: [string, string] = ['Start date', 'End date'];

  value: Date[] | null = null;
  disabled = false;

  private onChange: (value: Date[] | null) => void = () => {};
  private onTouched: () => void = () => {};

  writeValue(value: Date[] | null | undefined): void {
    this.value = Array.isArray(value) ? value : null;
  }

  registerOnChange(fn: (value: Date[] | null) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  handleChange(value: Date[] | null): void {
    this.value = value;
    this.onChange(value);
    this.onTouched();
  }
}
